import { Injectable } from '@angular/core';
import { Module } from '@models/module';
import {
  HttpCriteria,
  SuperHttpClientProvider
} from '@app/core/http';
import { Observable, ReplaySubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ModuloService {
  private _data$: ReplaySubject<any[]> = new ReplaySubject(1);
  public modulePowerSupplyTypes: any;

  constructor(private $$shttp: SuperHttpClientProvider) {
    this.setData([]);
  }

  private get $shttp() {
    return this.$$shttp.use('backoffice');
  }

  public getModulos<T = Module[]>(criteria: HttpCriteria): Observable<T> {
    const url = '/admin/module';
    return this.$shttp.filter<T>(url, criteria);
  }

  public get data$(): Observable<any[]> {
    return this._data$.asObservable();
  }

  public setData(data: any[]) {
    this._data$.next(data);
  }

  public getModulePowerSupplyTypes<T = any>(): Observable<T> {
    const url = '/enum/powerSupplyType';
    return this.$shttp.get<T>(url);
  }

  /*public getModulePowerSupplyTypes() {
    return this.$shttp.get('/enum/powerSupplyType');
  }*/

  public getEventsByModule(idModule: number) {
    return this.$shttp.get(
      `/admin/event?_filters=[{"field":"idModule","operator":"=","value":${idModule}}]`
    );
  }
}
